import type { CentralIconBaseProps } from "@central-icons-react/round-outlined-radius-2-stroke-2/CentralIconBase";
import type { ComponentType, NamedExoticComponent } from "react";
import type { ProductIcon, ProductIconProps } from "./product-icon-types.ts";
import RawIconFire1 from "@central-icons-react/round-outlined-radius-2-stroke-2/IconFire1";
import RawIconBroom from "@central-icons-react/round-outlined-radius-2-stroke-2/IconBroom";
import RawIconStar from "@central-icons-react/round-outlined-radius-2-stroke-2/IconStar";
import RawIconExclamationCircle from "@central-icons-react/round-outlined-radius-2-stroke-2/IconExclamationCircle";
import RawIconGauge from "@central-icons-react/round-outlined-radius-2-stroke-2/IconGauge";
import RawIconGenderFemale from "@central-icons-react/round-outlined-radius-2-stroke-2/IconGenderFemale";
import RawIconGenderMale from "@central-icons-react/round-outlined-radius-2-stroke-2/IconGenderMale";
import RawIconRuler from "@central-icons-react/round-outlined-radius-2-stroke-2/IconRuler";
import RawIconCircleDashed from "@central-icons-react/round-outlined-radius-2-stroke-2/IconCircleDashed";
import RawIconBrain from "@central-icons-react/round-outlined-radius-2-stroke-2/IconBrain";
import RawIconShieldCrossed from "@central-icons-react/round-outlined-radius-2-stroke-2/IconShieldCrossed";
import RawIconSidebarSimpleRightWide from "@central-icons-react/round-outlined-radius-2-stroke-2/IconSidebarSimpleRightWide";
import RawIconSidebarHiddenRightWide from "@central-icons-react/round-outlined-radius-2-stroke-2/IconSidebarHiddenRightWide";
import RawIconLayoutSidebar from "@central-icons-react/round-outlined-radius-2-stroke-2/IconLayoutSidebar";
import RawIconUsb from "@central-icons-react/round-outlined-radius-2-stroke-2/IconUsb";
import RawIconBold from "@central-icons-react/round-outlined-radius-2-stroke-2/IconBold";
import RawIconItalic from "@central-icons-react/round-outlined-radius-2-stroke-2/IconItalic";
import RawIconUnderline from "@central-icons-react/round-outlined-radius-2-stroke-2/IconUnderline";
import RawIconArrowCornerDownLeft from "@central-icons-react/round-outlined-radius-2-stroke-2/IconArrowCornerDownLeft";
import RawIconArrowShareRight from "@central-icons-react/round-outlined-radius-2-stroke-2/IconArrowShareRight";
import RawIconHand5Finger from "@central-icons-react/round-outlined-radius-2-stroke-2/IconHand5Finger";
import RawIconBurger from "@central-icons-react/round-outlined-radius-2-stroke-2/IconBurger";
import RawIconCar1 from "@central-icons-react/round-outlined-radius-2-stroke-2/IconCar1";
import RawIconBasketball from "@central-icons-react/round-outlined-radius-2-stroke-2/IconBasketball";
import RawIconLightBulb from "@central-icons-react/round-outlined-radius-2-stroke-2/IconLightBulb";
import RawIconHashtag from "@central-icons-react/round-outlined-radius-2-stroke-2/IconHashtag";
import RawIconFlag1 from "@central-icons-react/round-outlined-radius-2-stroke-2/IconFlag1";
import RawIconAirplane from "@central-icons-react/round-outlined-radius-2-stroke-2/IconAirplane";
import RawIconArchive from "@central-icons-react/round-outlined-radius-2-stroke-2/IconArchive";
import RawIconArrowDown from "@central-icons-react/round-outlined-radius-2-stroke-2/IconArrowDown";
import RawIconSquareArrowTopRight from "@central-icons-react/round-outlined-radius-2-stroke-2/IconSquareArrowTopRight";
import RawIconArrowLeft from "@central-icons-react/round-outlined-radius-2-stroke-2/IconArrowLeft";
import RawIconArrowRight from "@central-icons-react/round-outlined-radius-2-stroke-2/IconArrowRight";
import RawIconArrowRotateCounterClockwise from "@central-icons-react/round-outlined-radius-2-stroke-2/IconArrowRotateCounterClockwise";
import RawIconArrowRotateClockwise from "@central-icons-react/round-outlined-radius-2-stroke-2/IconArrowRotateClockwise";
import RawIconArrowUndoUp from "@central-icons-react/round-outlined-radius-2-stroke-2/IconArrowUndoUp";
import RawIconArrowUp from "@central-icons-react/round-outlined-radius-2-stroke-2/IconArrowUp";
import RawIconArrowUpRight from "@central-icons-react/round-outlined-radius-2-stroke-2/IconArrowUpRight";
import RawIconArrowRightLeft from "@central-icons-react/round-outlined-radius-2-stroke-2/IconArrowRightLeft";
import RawIconArrowTopBottom from "@central-icons-react/round-outlined-radius-2-stroke-2/IconArrowTopBottom";
import RawIconAt from "@central-icons-react/round-outlined-radius-2-stroke-2/IconAt";
import RawIconTrashCan from "@central-icons-react/round-outlined-radius-2-stroke-2/IconTrashCan";
import RawIconBookHeart from "@central-icons-react/round-outlined-radius-2-stroke-2/IconBookHeart";
import RawIconBuildings from "@central-icons-react/round-outlined-radius-2-stroke-2/IconBuildings";
import RawIconBirthdayCake from "@central-icons-react/round-outlined-radius-2-stroke-2/IconBirthdayCake";
import RawIconCalendar1 from "@central-icons-react/round-outlined-radius-2-stroke-2/IconCalendar1";
import RawIconElectrocardiogram from "@central-icons-react/round-outlined-radius-2-stroke-2/IconElectrocardiogram";
import RawIconBubbleAlert from "@central-icons-react/round-outlined-radius-2-stroke-2/IconBubbleAlert";
import RawIconBubbles from "@central-icons-react/round-outlined-radius-2-stroke-2/IconBubbles";
import RawIconQrCode from "@central-icons-react/round-outlined-radius-2-stroke-2/IconQrCode";
import RawIconVideo from "@central-icons-react/round-outlined-radius-2-stroke-2/IconVideo";
import RawIconCircleCheck from "@central-icons-react/round-outlined-radius-2-stroke-2/IconCircleCheck";
import RawIconCheckmark1 from "@central-icons-react/round-outlined-radius-2-stroke-2/IconCheckmark1";
import RawIconChevronDownMedium from "@central-icons-react/round-outlined-radius-2-stroke-2/IconChevronDownMedium";
import RawIconChevronLeftMedium from "@central-icons-react/round-outlined-radius-2-stroke-2/IconChevronLeftMedium";
import RawIconChevronRightMedium from "@central-icons-react/round-outlined-radius-2-stroke-2/IconChevronRightMedium";
import RawIconChevronTopMedium from "@central-icons-react/round-outlined-radius-2-stroke-2/IconChevronTopMedium";
import RawIconCirclePlaceholderOn from "@central-icons-react/round-outlined-radius-2-stroke-2/IconCirclePlaceholderOn";
import RawIconClipboard from "@central-icons-react/round-outlined-radius-2-stroke-2/IconClipboard";
import RawIconClock3OClock from "@central-icons-react/round-outlined-radius-2-stroke-2/IconClock3OClock";
import RawIconCloudDownload from "@central-icons-react/round-outlined-radius-2-stroke-2/IconCloudDownload";
import RawIconCloudUpload from "@central-icons-react/round-outlined-radius-2-stroke-2/IconCloudUpload";
import RawIconBrackets2 from "@central-icons-react/round-outlined-radius-2-stroke-2/IconBrackets2";
import RawIconSquareBehindSquare1 from "@central-icons-react/round-outlined-radius-2-stroke-2/IconSquareBehindSquare1";
import RawIconServer from "@central-icons-react/round-outlined-radius-2-stroke-2/IconServer";
import RawIconImac from "@central-icons-react/round-outlined-radius-2-stroke-2/IconImac";
import RawIconMacbook from "@central-icons-react/round-outlined-radius-2-stroke-2/IconMacbook";
import RawIconMoon from "@central-icons-react/round-outlined-radius-2-stroke-2/IconMoon";
import RawIconSun from "@central-icons-react/round-outlined-radius-2-stroke-2/IconSun";
import RawIconDotGrid1x3Horizontal from "@central-icons-react/round-outlined-radius-2-stroke-2/IconDotGrid1x3Horizontal";
import RawIconEmail2 from "@central-icons-react/round-outlined-radius-2-stroke-2/IconEmail2";
import RawIconExclamationTriangle from "@central-icons-react/round-outlined-radius-2-stroke-2/IconExclamationTriangle";
import RawIconEyeOpen from "@central-icons-react/round-outlined-radius-2-stroke-2/IconEyeOpen";
import RawIconEyeSlash from "@central-icons-react/round-outlined-radius-2-stroke-2/IconEyeSlash";
import RawIconFileText from "@central-icons-react/round-outlined-radius-2-stroke-2/IconFileText";
import RawIconFilter2 from "@central-icons-react/round-outlined-radius-2-stroke-2/IconFilter2";
import RawIconSettingsGear2 from "@central-icons-react/round-outlined-radius-2-stroke-2/IconSettingsGear2";
import RawIconGlobe from "@central-icons-react/round-outlined-radius-2-stroke-2/IconGlobe";
import RawIconGraduateCap from "@central-icons-react/round-outlined-radius-2-stroke-2/IconGraduateCap";
import RawIconDotGrid2x3 from "@central-icons-react/round-outlined-radius-2-stroke-2/IconDotGrid2x3";
import RawIconHeart from "@central-icons-react/round-outlined-radius-2-stroke-2/IconHeart";
import RawIconHistory from "@central-icons-react/round-outlined-radius-2-stroke-2/IconHistory";
import RawIconHomeOpen from "@central-icons-react/round-outlined-radius-2-stroke-2/IconHomeOpen";
import RawIconImages1 from "@central-icons-react/round-outlined-radius-2-stroke-2/IconImages1";
import RawIconInboxEmpty from "@central-icons-react/round-outlined-radius-2-stroke-2/IconInboxEmpty";
import RawIconFlashcards from "@central-icons-react/round-outlined-radius-2-stroke-2/IconFlashcards";
import RawIconChainLink4 from "@central-icons-react/round-outlined-radius-2-stroke-2/IconChainLink4";
import RawIconListBullets from "@central-icons-react/round-outlined-radius-2-stroke-2/IconListBullets";
import RawIconLock from "@central-icons-react/round-outlined-radius-2-stroke-2/IconLock";
import RawIconMagnifyingGlass from "@central-icons-react/round-outlined-radius-2-stroke-2/IconMagnifyingGlass";
import RawIconPlan from "@central-icons-react/round-outlined-radius-2-stroke-2/IconPlan";
import RawIconMicrophone from "@central-icons-react/round-outlined-radius-2-stroke-2/IconMicrophone";
import RawIconMicrophoneOff from "@central-icons-react/round-outlined-radius-2-stroke-2/IconMicrophoneOff";
import RawIconMapPin from "@central-icons-react/round-outlined-radius-2-stroke-2/IconMapPin";
import RawIconPaperclip1 from "@central-icons-react/round-outlined-radius-2-stroke-2/IconPaperclip1";
import RawIconPaperPlaneTopRight from "@central-icons-react/round-outlined-radius-2-stroke-2/IconPaperPlaneTopRight";
import RawIcon3dPackage2 from "@central-icons-react/round-outlined-radius-2-stroke-2/Icon3dPackage2";
import RawIconPause from "@central-icons-react/round-outlined-radius-2-stroke-2/IconPause";
import RawIconPets from "@central-icons-react/round-outlined-radius-2-stroke-2/IconPets";
import RawIconPencil from "@central-icons-react/round-outlined-radius-2-stroke-2/IconPencil";
import RawIconGroup1 from "@central-icons-react/round-outlined-radius-2-stroke-2/IconGroup1";
import RawIconUser from "@central-icons-react/round-outlined-radius-2-stroke-2/IconUser";
import RawIconUserAdd from "@central-icons-react/round-outlined-radius-2-stroke-2/IconUserAdd";
import RawIconPhone from "@central-icons-react/round-outlined-radius-2-stroke-2/IconPhone";
import RawIconPlayCircle from "@central-icons-react/round-outlined-radius-2-stroke-2/IconPlayCircle";
import RawIconPlay from "@central-icons-react/round-outlined-radius-2-stroke-2/IconPlay";
import RawIconPlusMedium from "@central-icons-react/round-outlined-radius-2-stroke-2/IconPlusMedium";
import RawIconEmojiSmile from "@central-icons-react/round-outlined-radius-2-stroke-2/IconEmojiSmile";
import RawIconRobot from "@central-icons-react/round-outlined-radius-2-stroke-2/IconRobot";
import RawIconShield from "@central-icons-react/round-outlined-radius-2-stroke-2/IconShield";
import RawIconSettingsSliderThree from "@central-icons-react/round-outlined-radius-2-stroke-2/IconSettingsSliderThree";
import RawIconSparklesThree from "@central-icons-react/round-outlined-radius-2-stroke-2/IconSparklesThree";
import RawIconFormSquare from "@central-icons-react/round-outlined-radius-2-stroke-2/IconFormSquare";
import RawIconNote1 from "@central-icons-react/round-outlined-radius-2-stroke-2/IconNote1";
import RawIconStopwatch from "@central-icons-react/round-outlined-radius-2-stroke-2/IconStopwatch";
import RawIconStore2 from "@central-icons-react/round-outlined-radius-2-stroke-2/IconStore2";
import RawIconTag from "@central-icons-react/round-outlined-radius-2-stroke-2/IconTag";
import RawIconCircleInfo from "@central-icons-react/round-outlined-radius-2-stroke-2/IconCircleInfo";
import RawIconTrending3 from "@central-icons-react/round-outlined-radius-2-stroke-2/IconTrending3";
import RawIconFastShipping from "@central-icons-react/round-outlined-radius-2-stroke-2/IconFastShipping";
import RawIconVolumeFull from "@central-icons-react/round-outlined-radius-2-stroke-2/IconVolumeFull";
import RawIconVolumeOff from "@central-icons-react/round-outlined-radius-2-stroke-2/IconVolumeOff";
import RawIconMaintenance from "@central-icons-react/round-outlined-radius-2-stroke-2/IconMaintenance";
import RawIconCircleX from "@central-icons-react/round-outlined-radius-2-stroke-2/IconCircleX";
import RawIconCrossMedium from "@central-icons-react/round-outlined-radius-2-stroke-2/IconCrossMedium";
import RawIconExpand45 from "@central-icons-react/round-outlined-radius-2-stroke-2/IconExpand45";
import RawIconMinimize45 from "@central-icons-react/round-outlined-radius-2-stroke-2/IconMinimize45";
import RawIconFacebook from "@central-icons-react/round-outlined-radius-2-stroke-2/IconFacebook";
import RawIconInstagram from "@central-icons-react/round-outlined-radius-2-stroke-2/IconInstagram";
import RawIconYoutube from "@central-icons-react/round-outlined-radius-2-stroke-2/IconYoutube";
import RawIconX from "@central-icons-react/round-outlined-radius-2-stroke-2/IconX";
import RawIconPinterest from "@central-icons-react/round-outlined-radius-2-stroke-2/IconPinterest";
import RawIconTiktok from "@central-icons-react/round-outlined-radius-2-stroke-2/IconTiktok";
import RawIconThreads from "@central-icons-react/round-outlined-radius-2-stroke-2/IconThreads";
import RawIconLinkedin from "@central-icons-react/round-outlined-radius-2-stroke-2/IconLinkedin";
import RawIconPlayFilled from "@central-icons-react/round-filled-radius-2-stroke-2/IconPlay";
import RawIconPauseFilled from "@central-icons-react/round-filled-radius-2-stroke-2/IconPause";
import RawIconVolumeFullFilled from "@central-icons-react/round-filled-radius-2-stroke-2/IconVolumeFull";
import RawIconVolumeOffFilled from "@central-icons-react/round-filled-radius-2-stroke-2/IconVolumeOff";
import RawIconExpand45Filled from "@central-icons-react/round-filled-radius-2-stroke-2/IconExpand45";
import RawIconMinimize45Filled from "@central-icons-react/round-filled-radius-2-stroke-2/IconMinimize45";
import RawIconPetsFilled from "@central-icons-react/round-filled-radius-2-stroke-2/IconPets";
import RawIconStarFilled from "@central-icons-react/round-filled-radius-2-stroke-2/IconStar";
import RawIconTennisFilled from "@central-icons-react/round-filled-radius-2-stroke-2/IconTennis";
import RawIconEmail2Filled from "@central-icons-react/round-filled-radius-2-stroke-2/IconEmail2";
import RawIconBookHeartFilled from "@central-icons-react/round-filled-radius-2-stroke-2/IconBookHeart";
import RawIconHeartFilled from "@central-icons-react/round-filled-radius-2-stroke-2/IconHeart";
import RawIconHomeOpenFilled from "@central-icons-react/round-filled-radius-2-stroke-2/IconHomeOpen";
import RawIconHourglass from "@central-icons-react/round-outlined-radius-2-stroke-2/IconHourglass";
import RawIconCircleBanSign from "@central-icons-react/round-outlined-radius-2-stroke-2/IconCircleBanSign";
import RawIconCircleCheckFilled from "@central-icons-react/round-filled-radius-2-stroke-2/IconCircleCheck";
import RawIconHourglassFilled from "@central-icons-react/round-filled-radius-2-stroke-2/IconHourglass";
import RawIconFlashcardsFilled from "@central-icons-react/round-filled-radius-2-stroke-2/IconFlashcards";
import RawIconUserFilled from "@central-icons-react/round-filled-radius-2-stroke-2/IconUser";
import RawIconPeopleCircleFilled from "@central-icons-react/round-filled-radius-2-stroke-2/IconPeopleCircle";
import RawIconBubbleTextFilled from "@central-icons-react/round-filled-radius-2-stroke-2/IconBubbleText";
import RawIconFormSealFilled from "@central-icons-react/round-filled-radius-2-stroke-2/IconFormSeal";
import RawIconCheckmark2SmallFilled from "@central-icons-react/round-filled-radius-2-stroke-2/IconCheckmark2Small";
import RawIconHomeOpenLight from "@central-icons-react/round-outlined-radius-2-stroke-1.5/IconHomeOpen";
import RawIconFlashcardsLight from "@central-icons-react/round-outlined-radius-2-stroke-1.5/IconFlashcards";
import RawIconHeartLight from "@central-icons-react/round-outlined-radius-2-stroke-1.5/IconHeart";
import RawIconBookHeartLight from "@central-icons-react/round-outlined-radius-2-stroke-1.5/IconBookHeart";
import RawIconUserLight from "@central-icons-react/round-outlined-radius-2-stroke-1.5/IconUser";
import RawIconPeopleCircleLight from "@central-icons-react/round-outlined-radius-2-stroke-1.5/IconPeopleCircle";
import RawIconLayoutGrid2Light from "@central-icons-react/round-outlined-radius-2-stroke-1.5/IconLayoutGrid2";
import RawIconLayoutGrid2Filled from "@central-icons-react/round-filled-radius-2-stroke-2/IconLayoutGrid2";
import RawIconInboxEmptyLight from "@central-icons-react/round-outlined-radius-2-stroke-1.5/IconInboxEmpty";
import RawIconDotGrid1x3HorizontalLight from "@central-icons-react/round-outlined-radius-2-stroke-1.5/IconDotGrid1x3Horizontal";
import RawIconInboxEmptyFilled from "@central-icons-react/round-filled-radius-2-stroke-2/IconInboxEmpty";
import RawIconDotGrid1x3HorizontalFilled from "@central-icons-react/round-filled-radius-2-stroke-2/IconDotGrid1x3Horizontal";
import RawIconMapPinFilled from "@central-icons-react/round-filled-radius-2-stroke-2/IconMapPin";

type CentralComponent =
    | ComponentType<CentralIconBaseProps>
    | NamedExoticComponent<CentralIconBaseProps>;

/*#__NO_SIDE_EFFECTS__*/
function createCentralIcon(Icon: CentralComponent, name: string): ProductIcon {
    const CentralProductIcon = ({
        "aria-hidden": ariaHidden,
        mode: _mode,
        ...props
    }: ProductIconProps) => {
        const hidden =
            ariaHidden === undefined
                ? !(
                      props["aria-label"] ||
                      props["aria-labelledby"] ||
                      props.role
                  )
                : ariaHidden === true || ariaHidden === "true";
        return <Icon {...props} ariaHidden={hidden} mode="raw" />;
    };
    CentralProductIcon.displayName = `CentralIcon(${name})`;
    return CentralProductIcon;
}

export const IconFire1 = createCentralIcon(RawIconFire1, "IconFire1");
export const IconBroom = createCentralIcon(RawIconBroom, "IconBroom");
export const IconStar = createCentralIcon(RawIconStar, "IconStar");
export const IconExclamationCircle = createCentralIcon(
    RawIconExclamationCircle,
    "IconExclamationCircle",
);
export const IconGauge = createCentralIcon(RawIconGauge, "IconGauge");
export const IconGenderFemale = createCentralIcon(
    RawIconGenderFemale,
    "IconGenderFemale",
);
export const IconGenderMale = createCentralIcon(
    RawIconGenderMale,
    "IconGenderMale",
);
export const IconRuler = createCentralIcon(RawIconRuler, "IconRuler");
export const IconCircleDashed = createCentralIcon(
    RawIconCircleDashed,
    "IconCircleDashed",
);
export const IconBrain = createCentralIcon(RawIconBrain, "IconBrain");
export const IconShieldCrossed = createCentralIcon(
    RawIconShieldCrossed,
    "IconShieldCrossed",
);
export const IconSidebarSimpleRightWide = createCentralIcon(
    RawIconSidebarSimpleRightWide,
    "IconSidebarSimpleRightWide",
);
export const IconSidebarHiddenRightWide = createCentralIcon(
    RawIconSidebarHiddenRightWide,
    "IconSidebarHiddenRightWide",
);
export const IconLayoutSidebar = createCentralIcon(
    RawIconLayoutSidebar,
    "IconLayoutSidebar",
);
export const IconUsb = createCentralIcon(RawIconUsb, "IconUsb");
export const IconBold = createCentralIcon(RawIconBold, "IconBold");
export const IconItalic = createCentralIcon(RawIconItalic, "IconItalic");
export const IconUnderline = createCentralIcon(
    RawIconUnderline,
    "IconUnderline",
);
export const IconArrowCornerDownLeft = createCentralIcon(
    RawIconArrowCornerDownLeft,
    "IconArrowCornerDownLeft",
);
export const IconArrowShareRight = createCentralIcon(
    RawIconArrowShareRight,
    "IconArrowShareRight",
);
export const IconHand5Finger = createCentralIcon(
    RawIconHand5Finger,
    "IconHand5Finger",
);
export const IconBurger = createCentralIcon(RawIconBurger, "IconBurger");
export const IconCar1 = createCentralIcon(RawIconCar1, "IconCar1");
export const IconBasketball = createCentralIcon(
    RawIconBasketball,
    "IconBasketball",
);
export const IconLightBulb = createCentralIcon(
    RawIconLightBulb,
    "IconLightBulb",
);
export const IconHashtag = createCentralIcon(RawIconHashtag, "IconHashtag");
export const IconFlag1 = createCentralIcon(RawIconFlag1, "IconFlag1");
export const IconAirplane = createCentralIcon(RawIconAirplane, "IconAirplane");
export const IconArchive = createCentralIcon(RawIconArchive, "IconArchive");
export const IconArrowDown = createCentralIcon(
    RawIconArrowDown,
    "IconArrowDown",
);
export const IconSquareArrowTopRight = createCentralIcon(
    RawIconSquareArrowTopRight,
    "IconSquareArrowTopRight",
);
export const IconArrowLeft = createCentralIcon(
    RawIconArrowLeft,
    "IconArrowLeft",
);
export const IconArrowRight = createCentralIcon(
    RawIconArrowRight,
    "IconArrowRight",
);
export const IconArrowRotateCounterClockwise = createCentralIcon(
    RawIconArrowRotateCounterClockwise,
    "IconArrowRotateCounterClockwise",
);
export const IconArrowRotateClockwise = createCentralIcon(
    RawIconArrowRotateClockwise,
    "IconArrowRotateClockwise",
);
export const IconArrowUndoUp = createCentralIcon(
    RawIconArrowUndoUp,
    "IconArrowUndoUp",
);
export const IconArrowUp = createCentralIcon(RawIconArrowUp, "IconArrowUp");
export const IconArrowUpRight = createCentralIcon(
    RawIconArrowUpRight,
    "IconArrowUpRight",
);
export const IconArrowRightLeft = createCentralIcon(
    RawIconArrowRightLeft,
    "IconArrowRightLeft",
);
export const IconArrowTopBottom = createCentralIcon(
    RawIconArrowTopBottom,
    "IconArrowTopBottom",
);
export const IconAt = createCentralIcon(RawIconAt, "IconAt");
export const IconTrashCan = createCentralIcon(RawIconTrashCan, "IconTrashCan");
export const IconBookHeart = createCentralIcon(
    RawIconBookHeart,
    "IconBookHeart",
);
export const IconBuildings = createCentralIcon(
    RawIconBuildings,
    "IconBuildings",
);
export const IconBirthdayCake = createCentralIcon(
    RawIconBirthdayCake,
    "IconBirthdayCake",
);
export const IconCalendar1 = createCentralIcon(
    RawIconCalendar1,
    "IconCalendar1",
);
export const IconElectrocardiogram = createCentralIcon(
    RawIconElectrocardiogram,
    "IconElectrocardiogram",
);
export const IconBubbleAlert = createCentralIcon(
    RawIconBubbleAlert,
    "IconBubbleAlert",
);
export const IconBubbles = createCentralIcon(RawIconBubbles, "IconBubbles");
export const IconQrCode = createCentralIcon(RawIconQrCode, "IconQrCode");
export const IconVideo = createCentralIcon(RawIconVideo, "IconVideo");
export const IconCircleCheck = createCentralIcon(
    RawIconCircleCheck,
    "IconCircleCheck",
);
export const IconCheckmark1 = createCentralIcon(
    RawIconCheckmark1,
    "IconCheckmark1",
);
export const IconChevronDownMedium = createCentralIcon(
    RawIconChevronDownMedium,
    "IconChevronDownMedium",
);
export const IconChevronLeftMedium = createCentralIcon(
    RawIconChevronLeftMedium,
    "IconChevronLeftMedium",
);
export const IconChevronRightMedium = createCentralIcon(
    RawIconChevronRightMedium,
    "IconChevronRightMedium",
);
export const IconChevronTopMedium = createCentralIcon(
    RawIconChevronTopMedium,
    "IconChevronTopMedium",
);
export const IconCirclePlaceholderOn = createCentralIcon(
    RawIconCirclePlaceholderOn,
    "IconCirclePlaceholderOn",
);
export const IconClipboard = createCentralIcon(
    RawIconClipboard,
    "IconClipboard",
);
export const IconClock3OClock = createCentralIcon(
    RawIconClock3OClock,
    "IconClock3OClock",
);
export const IconCloudDownload = createCentralIcon(
    RawIconCloudDownload,
    "IconCloudDownload",
);
export const IconCloudUpload = createCentralIcon(
    RawIconCloudUpload,
    "IconCloudUpload",
);
export const IconBrackets2 = createCentralIcon(
    RawIconBrackets2,
    "IconBrackets2",
);
export const IconSquareBehindSquare1 = createCentralIcon(
    RawIconSquareBehindSquare1,
    "IconSquareBehindSquare1",
);
export const IconServer = createCentralIcon(RawIconServer, "IconServer");
export const IconImac = createCentralIcon(RawIconImac, "IconImac");
export const IconMacbook = createCentralIcon(RawIconMacbook, "IconMacbook");
export const IconMoon = createCentralIcon(RawIconMoon, "IconMoon");
export const IconSun = createCentralIcon(RawIconSun, "IconSun");
export const IconDotGrid1x3Horizontal = createCentralIcon(
    RawIconDotGrid1x3Horizontal,
    "IconDotGrid1x3Horizontal",
);
export const IconEmail2 = createCentralIcon(RawIconEmail2, "IconEmail2");
export const IconExclamationTriangle = createCentralIcon(
    RawIconExclamationTriangle,
    "IconExclamationTriangle",
);
export const IconEyeOpen = createCentralIcon(RawIconEyeOpen, "IconEyeOpen");
export const IconEyeSlash = createCentralIcon(RawIconEyeSlash, "IconEyeSlash");
export const IconFileText = createCentralIcon(RawIconFileText, "IconFileText");
export const IconFilter2 = createCentralIcon(RawIconFilter2, "IconFilter2");
export const IconSettingsGear2 = createCentralIcon(
    RawIconSettingsGear2,
    "IconSettingsGear2",
);
export const IconGlobe = createCentralIcon(RawIconGlobe, "IconGlobe");
export const IconGraduateCap = createCentralIcon(
    RawIconGraduateCap,
    "IconGraduateCap",
);
export const IconDotGrid2x3 = createCentralIcon(
    RawIconDotGrid2x3,
    "IconDotGrid2x3",
);
export const IconHeart = createCentralIcon(RawIconHeart, "IconHeart");
export const IconHistory = createCentralIcon(RawIconHistory, "IconHistory");
export const IconHomeOpen = createCentralIcon(RawIconHomeOpen, "IconHomeOpen");
export const IconImages1 = createCentralIcon(RawIconImages1, "IconImages1");
export const IconInboxEmpty = createCentralIcon(
    RawIconInboxEmpty,
    "IconInboxEmpty",
);
export const IconFlashcards = createCentralIcon(
    RawIconFlashcards,
    "IconFlashcards",
);
export const IconChainLink4 = createCentralIcon(
    RawIconChainLink4,
    "IconChainLink4",
);
export const IconListBullets = createCentralIcon(
    RawIconListBullets,
    "IconListBullets",
);
export const IconLock = createCentralIcon(RawIconLock, "IconLock");
export const IconMagnifyingGlass = createCentralIcon(
    RawIconMagnifyingGlass,
    "IconMagnifyingGlass",
);
export const IconPlan = createCentralIcon(RawIconPlan, "IconPlan");
export const IconMicrophone = createCentralIcon(
    RawIconMicrophone,
    "IconMicrophone",
);
export const IconMicrophoneOff = createCentralIcon(
    RawIconMicrophoneOff,
    "IconMicrophoneOff",
);
export const IconMapPin = createCentralIcon(RawIconMapPin, "IconMapPin");
export const IconPaperclip1 = createCentralIcon(
    RawIconPaperclip1,
    "IconPaperclip1",
);
export const IconPaperPlaneTopRight = createCentralIcon(
    RawIconPaperPlaneTopRight,
    "IconPaperPlaneTopRight",
);
export const Icon3dPackage2 = createCentralIcon(
    RawIcon3dPackage2,
    "Icon3dPackage2",
);
export const IconPause = createCentralIcon(RawIconPause, "IconPause");
export const IconPets = createCentralIcon(RawIconPets, "IconPets");
export const IconPencil = createCentralIcon(RawIconPencil, "IconPencil");
export const IconGroup1 = createCentralIcon(RawIconGroup1, "IconGroup1");
export const IconUser = createCentralIcon(RawIconUser, "IconUser");
export const IconUserAdd = createCentralIcon(RawIconUserAdd, "IconUserAdd");
export const IconEmojiSmile = createCentralIcon(
    RawIconEmojiSmile,
    "IconEmojiSmile",
);
export const IconPhone = createCentralIcon(RawIconPhone, "IconPhone");
export const IconPlayCircle = createCentralIcon(
    RawIconPlayCircle,
    "IconPlayCircle",
);
export const IconPlay = createCentralIcon(RawIconPlay, "IconPlay");
export const IconPlusMedium = createCentralIcon(
    RawIconPlusMedium,
    "IconPlusMedium",
);
export const IconRobot = createCentralIcon(RawIconRobot, "IconRobot");
export const IconShield = createCentralIcon(RawIconShield, "IconShield");
export const IconSettingsSliderThree = createCentralIcon(
    RawIconSettingsSliderThree,
    "IconSettingsSliderThree",
);
export const IconSparklesThree = createCentralIcon(
    RawIconSparklesThree,
    "IconSparklesThree",
);
export const IconFormSquare = createCentralIcon(
    RawIconFormSquare,
    "IconFormSquare",
);
export const IconNote1 = createCentralIcon(RawIconNote1, "IconNote1");
export const IconStopwatch = createCentralIcon(
    RawIconStopwatch,
    "IconStopwatch",
);
export const IconStore2 = createCentralIcon(RawIconStore2, "IconStore2");
export const IconTag = createCentralIcon(RawIconTag, "IconTag");
export const IconCircleInfo = createCentralIcon(
    RawIconCircleInfo,
    "IconCircleInfo",
);
export const IconTrending3 = createCentralIcon(
    RawIconTrending3,
    "IconTrending3",
);
export const IconFastShipping = createCentralIcon(
    RawIconFastShipping,
    "IconFastShipping",
);
export const IconVolumeFull = createCentralIcon(
    RawIconVolumeFull,
    "IconVolumeFull",
);
export const IconVolumeOff = createCentralIcon(
    RawIconVolumeOff,
    "IconVolumeOff",
);
export const IconMaintenance = createCentralIcon(
    RawIconMaintenance,
    "IconMaintenance",
);
export const IconCircleX = createCentralIcon(RawIconCircleX, "IconCircleX");
export const IconCrossMedium = createCentralIcon(
    RawIconCrossMedium,
    "IconCrossMedium",
);
export const IconExpand45 = createCentralIcon(RawIconExpand45, "IconExpand45");
export const IconMinimize45 = createCentralIcon(
    RawIconMinimize45,
    "IconMinimize45",
);
export const IconFacebook = createCentralIcon(RawIconFacebook, "IconFacebook");
export const IconInstagram = createCentralIcon(
    RawIconInstagram,
    "IconInstagram",
);
export const IconYoutube = createCentralIcon(RawIconYoutube, "IconYoutube");
export const IconX = createCentralIcon(RawIconX, "IconX");
export const IconPinterest = createCentralIcon(
    RawIconPinterest,
    "IconPinterest",
);
export const IconTiktok = createCentralIcon(RawIconTiktok, "IconTiktok");
export const IconThreads = createCentralIcon(RawIconThreads, "IconThreads");
export const IconLinkedin = createCentralIcon(RawIconLinkedin, "IconLinkedin");
export const IconPlayFilled = createCentralIcon(
    RawIconPlayFilled,
    "IconPlayFilled",
);
export const IconPauseFilled = createCentralIcon(
    RawIconPauseFilled,
    "IconPauseFilled",
);
export const IconVolumeFullFilled = createCentralIcon(
    RawIconVolumeFullFilled,
    "IconVolumeFullFilled",
);
export const IconVolumeOffFilled = createCentralIcon(
    RawIconVolumeOffFilled,
    "IconVolumeOffFilled",
);
export const IconExpand45Filled = createCentralIcon(
    RawIconExpand45Filled,
    "IconExpand45Filled",
);
export const IconMinimize45Filled = createCentralIcon(
    RawIconMinimize45Filled,
    "IconMinimize45Filled",
);
export const IconPetsFilled = createCentralIcon(
    RawIconPetsFilled,
    "IconPetsFilled",
);
export const IconStarFilled = createCentralIcon(
    RawIconStarFilled,
    "IconStarFilled",
);
export const IconTennisFilled = createCentralIcon(
    RawIconTennisFilled,
    "IconTennisFilled",
);

export const IconEmail2Filled = createCentralIcon(
    RawIconEmail2Filled,
    "IconEmail2Filled",
);
export const IconBookHeartFilled = createCentralIcon(
    RawIconBookHeartFilled,
    "IconBookHeartFilled",
);
export const IconHeartFilled = createCentralIcon(
    RawIconHeartFilled,
    "IconHeartFilled",
);
export const IconHomeOpenFilled = createCentralIcon(
    RawIconHomeOpenFilled,
    "IconHomeOpenFilled",
);
export const IconHourglass = createCentralIcon(
    RawIconHourglass,
    "IconHourglass",
);
export const IconCircleBanSign = createCentralIcon(
    RawIconCircleBanSign,
    "IconCircleBanSign",
);
export const IconCircleCheckFilled = createCentralIcon(
    RawIconCircleCheckFilled,
    "IconCircleCheckFilled",
);
export const IconHourglassFilled = createCentralIcon(
    RawIconHourglassFilled,
    "IconHourglassFilled",
);
export const IconFlashcardsFilled = createCentralIcon(
    RawIconFlashcardsFilled,
    "IconFlashcardsFilled",
);
export const IconUserFilled = createCentralIcon(
    RawIconUserFilled,
    "IconUserFilled",
);
export const IconPeopleCircleFilled = createCentralIcon(
    RawIconPeopleCircleFilled,
    "IconPeopleCircleFilled",
);
export const IconBubbleTextFilled = createCentralIcon(
    RawIconBubbleTextFilled,
    "IconBubbleTextFilled",
);
export const IconFormSealFilled = createCentralIcon(
    RawIconFormSealFilled,
    "IconFormSealFilled",
);
export const IconCheckmark2SmallFilled = createCentralIcon(
    RawIconCheckmark2SmallFilled,
    "IconCheckmark2SmallFilled",
);
export const IconHomeOpenLight = createCentralIcon(
    RawIconHomeOpenLight,
    "IconHomeOpenLight",
);
export const IconFlashcardsLight = createCentralIcon(
    RawIconFlashcardsLight,
    "IconFlashcardsLight",
);
export const IconHeartLight = createCentralIcon(
    RawIconHeartLight,
    "IconHeartLight",
);
export const IconBookHeartLight = createCentralIcon(
    RawIconBookHeartLight,
    "IconBookHeartLight",
);
export const IconUserLight = createCentralIcon(
    RawIconUserLight,
    "IconUserLight",
);
export const IconPeopleCircleLight = createCentralIcon(
    RawIconPeopleCircleLight,
    "IconPeopleCircleLight",
);
export const IconLayoutGrid2Light = createCentralIcon(
    RawIconLayoutGrid2Light,
    "IconLayoutGrid2Light",
);
export const IconLayoutGrid2Filled = createCentralIcon(
    RawIconLayoutGrid2Filled,
    "IconLayoutGrid2Filled",
);
export const IconInboxEmptyLight = createCentralIcon(
    RawIconInboxEmptyLight,
    "IconInboxEmptyLight",
);
export const IconDotGrid1x3HorizontalLight = createCentralIcon(
    RawIconDotGrid1x3HorizontalLight,
    "IconDotGrid1x3HorizontalLight",
);
export const IconInboxEmptyFilled = createCentralIcon(
    RawIconInboxEmptyFilled,
    "IconInboxEmptyFilled",
);
export const IconDotGrid1x3HorizontalFilled = createCentralIcon(
    RawIconDotGrid1x3HorizontalFilled,
    "IconDotGrid1x3HorizontalFilled",
);
export const IconMapPinFilled = createCentralIcon(
    RawIconMapPinFilled,
    "IconMapPinFilled",
);
